export const environment = {
  production: true,
  buildId: '3668408958822991',
  configFile: 'config.json',
};
